export const isAuthenticationFailure = (error) => {
  const status = error?.response?.status ?? error?.response?.data?.status;
  return status === 401 || status === 403;
};
